import { toast } from 'react-toastify';

import api from 'services/api';

type DeliveryMethod = 'DOWNLOAD' | 'EMAIL';
type DocumentType = 'DANFE' | 'XML';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
});

export const downloadInvoicePdf = async (invoiceId: string): Promise<void> => {
  const customerCode = localStorage.getItem('@UltragazEmpresarial:customerCode');
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');

  const body = {
    customerCode,
    customerSiteCode,
    documentType: 'DANFE' as DocumentType,
    deliveryMethod: 'DOWNLOAD' as DeliveryMethod,
    ...(contactIdSf && { contactIdSf }),
  };

  const response = await api.post(
    `industrial/invoice/v1/invoices/${invoiceId}`,
    body,
    {
      method: 'POST',
      responseType: 'blob',
      headers: getAuthHeaders(),
    } as Parameters<typeof api.post>[2]
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${invoiceId}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  toast.success('Nota baixada. Confira sua pasta de downloads.');
};

export const downloadInvoiceXml = async (invoiceId: string): Promise<void> => {
  const customerCode = localStorage.getItem('@UltragazEmpresarial:customerCode');
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');

  const body = {
    customerCode,
    customerSiteCode,
    documentType: 'XML' as DocumentType,
    deliveryMethod: 'DOWNLOAD' as DeliveryMethod,
    ...(contactIdSf && { contactIdSf }),
  };

  const response = await api.post(
    `industrial/invoice/v1/invoices/${invoiceId}`,
    body,
    {
      method: 'POST',
      responseType: 'blob',
      headers: getAuthHeaders(),
    } as Parameters<typeof api.post>[2]
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${invoiceId}.xml`);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  toast.success('XML baixado com sucesso.');
};

export type InvoiceEmailFormat = 'XML' | 'PDF';

const toDocumentType = (format: InvoiceEmailFormat): DocumentType =>
  format === 'XML' ? 'XML' : 'DANFE';

export const emailInvoice = async (
  invoiceId: string,
  options: { email: string; format: InvoiceEmailFormat }
): Promise<void> => {
  const customerCode = localStorage.getItem('@UltragazEmpresarial:customerCode');
  const customerSiteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );
  const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');

  const body = {
    customerCode,
    customerSiteCode,
    documentType: toDocumentType(options.format),
    deliveryMethod: 'EMAIL' as DeliveryMethod,
    email: options.email,
    ...(contactIdSf && { contactIdSf }),
  };

  await api.post(`industrial/invoice/v1/invoices/${invoiceId}`, body, {
    method: 'POST',
    headers: getAuthHeaders(),
  } as Parameters<typeof api.post>[2]);

  toast.success(
    `Nota fiscal (${options.format}) enviada para o e-mail ${options.email}`
  );
};
